export default (number, addSuffix = true, round = false, seperator = ".") => {
  if (number > 999999) {
    return `${(number / 1000000)
      .toFixed(round ? 0 : 1)
      .replace(/\./gi, seperator)}${addSuffix ? "m" : ""}`;
  }

  if (number > 999) {
    return `${(number / 1000)
      .toFixed(round ? 0 : 0)
      .replace(/\./gi, seperator)}${addSuffix ? "k" : ""}`;
  }

  if (number === 0) {
    return number;
  }

  if (number < 1) {
    return parseFloat(number.toFixed(2))
      .toString()
      .replace(/\./gi, seperator);
  }

  return Math.round(number);
};



// WEBPACK FOOTER //
// ./src/utils/formatNumber.js